import { render, staticRenderFns } from "./AdsItem.vue?vue&type=template&id=50f98a33&scoped=true"
import script from "./AdsItem.vue?vue&type=script&lang=js"
export * from "./AdsItem.vue?vue&type=script&lang=js"
import style0 from "./AdsItem.vue?vue&type=style&index=0&id=50f98a33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f98a33",
  null
  
)

export default component.exports